module.exports = __webpack_public_path__ + "static/media/plus.657b606e.svg";